export class Permission {
  id:number;
  roleID:number;
  operationID: number;
  operationName: string;
  type?: string;
  allowsGET: boolean;
  allowsPOST: boolean;
  allowsPUT: boolean;
  allowsDELETE: boolean;
}

export enum ApiMethods {
  GET, POST, PUT, DELETE
}

export class PermissionConfigurationBase {
  ms_base: string;
  operation: string;
}

export class PermissionConfiguration extends PermissionConfigurationBase {
  method?: ApiMethods;
}



// WEBPACK FOOTER //
// ./src/app/models/permission.model.ts